export enum CompanyDetailsTabId {
  MobileRoot = 'mobile-root',
  CompanyName = 'description',
  PracticeAddresses = 'practice-addresses',
  ExternalAuth = 'external-auth',
  InsuranceCatalog = 'insurance',
  NPI = 'npi',
}
